// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2c613a{margin-right:1em;font-size:.75em}._2c613a.is-checked~span{text-decoration:line-through;opacity:.35}._3b1b65{display:flex;alignItems:\"center\"}._3b1b65 span{font-weight:500}._842813{position:relative;z-index:2}._842813 li{display:flex}._842813 li+li{margin-top:.5em}.e2b180{font-size:.875em;margin-left:.5em}.e2b180 span{color:var(--highlight) !important}._4d5835{font-size:13px;margin-top:5px}", ""]);
// Exports
exports.locals = {
	"checkbox": "_2c613a",
	"weeklyObjectiveLabel": "_3b1b65",
	"list": "_842813",
	"checkList": "e2b180 _842813",
	"weekDates": "_4d5835"
};
module.exports = exports;
